export default __webpack_public_path__ + "static/media/essence.c960c8ac.png";